import reduceReducers from 'reduce-reducers'
import { has, isArray, cloneDeep, mergeWith, uniqWith, unset, isEqual } from 'lodash'
import * as R from 'ramda'

import {
  CLEAR_ENTITIES,
  CLEAR_RESULTS,
  UPDATE_ENTITIES,
  UPDATE_RESULTS,
  REMOVE_ENTITIES,
  REMOVE_RESULTS,
  REMOVE_ENTITY_ROW,
  REMOVE_RESULT_ROW,
  OVERWRITE_ENTITIES,
  OVERWRITE_RESULTS
} from './constants'
import {
  updateObject,
  createReducer,
} from 'helpers/ReducerUtil'
import {
  pgmElementCrossReducer
} from 'containers/ProductPgmOverview/reducer'
import {
  productElementCrossReducer
} from 'containers/ProductOverview/reducer'

const uniqueConcat = (objValue, srcValue) => {
  if (isArray(objValue)){
    return uniqWith(objValue.concat(srcValue), isEqual)
  }
}

const mapIdsToInteger = R.compose(
  R.fromPairs,
  R.map(([k, v]) => [k, R.map((id) => parseInt(id))(v)]),
  R.toPairs
)

const updateEntities = (state, action) => {
  const newState = cloneDeep(state)
  return mergeWith(newState, action.entities, uniqueConcat)
}

const updateResults = (state, action) => {
  const newState = cloneDeep(state)
  const newResults = mapIdsToInteger(action.results)
  return mergeWith(newState, newResults, uniqueConcat)
}

const removeTable = (state, action) => {
  let newState = state
  const { tableName } = action
  if (has(state, tableName)) {
    newState = cloneDeep(state)
    unset(newState, tableName)
  }
  return newState
}

const removeResultRow = (prev, { tableName, id }) => {
  return {
    ...prev,
    [tableName]: R.reject(R.equals(parseInt(id)))(prev[tableName])
  }
}

const removeEntityRow = (prev, { tableName, id }) => {
  return {
    ...prev,
    [tableName]: R.dissoc(id)(prev[tableName])
  }
}

const overwriteEntities = (state, action) => {
  const newState = cloneDeep(state)
  return Object.assign(newState, action.entities)
}

const overwriteResults = (state, action) => {
  const newState = cloneDeep(state)
  const newResults = mapIdsToInteger(action.results)
  return Object.assign(newState, newResults)
}

export const entityReducer = createReducer({}, {
  [CLEAR_ENTITIES]: () => { return {} },
  [UPDATE_ENTITIES]: updateEntities,
  [REMOVE_ENTITIES]: removeTable,
  [REMOVE_ENTITY_ROW]: removeEntityRow,
  [OVERWRITE_ENTITIES]: overwriteEntities
})

export const resultReducer = createReducer({}, {
  [CLEAR_RESULTS]: () => { return {} },
  [UPDATE_RESULTS]: updateResults,
  [REMOVE_RESULTS]: removeTable,
  [REMOVE_RESULT_ROW]: removeResultRow,
  [OVERWRITE_RESULTS]: overwriteResults
})

// make sure all the special reducers are imported here that need the entity
// and results states
export const rootEntityReducer = reduceReducers(
  productElementCrossReducer,
  pgmElementCrossReducer
)
